export enum TabListLabelRegistered {
  active = 'Aktif',
  registered = 'Menunggu KUL',
  nonactive = 'Nonaktif',
}

export enum TabListLabelPending {
  registration_request = 'Pengajuan Pendaftaran',
  verification_request = 'Pengajuan Verifikasi',
  edit_request = 'Pengajuan Pembaruan Data',
  non_active = 'Pengajuan Penonaktifan',
  // finance_edit_request = 'Pembaruan Data Finance',
}

export enum TabListLabelRejected {
  registration_reject = 'Pendaftaran Ditolak',
  verification_reject = 'Verifikasi Ditolak',
}

export enum TabListLabelDetailDistributor {
  informasi_npwp = 'Informasi NPWP',
  informasi_kul = 'Informasi KUL',
  informasi_distributor = 'Informasi Distributor',
  alamat_pengiriman = 'Alamat Pengiriman',
  plafon_kredit = 'Plafon Kredit',
  product_exclusive = 'Product Exclusive',
  program_target = 'Program Target',
  dokumen = 'Dokumen',
  log = 'Log',
}

export enum TabLabelEnumDetailDistributor {
  TAB_NPWP_INFORMATION = 'TAB_NPWP_INFORMATION',
  TAB_KUL_INFORMATION = 'TAB_KUL_INFORMATION',
  TAB_DISTRIBUTOR_INFORMATION = 'TAB_DISTRIBUTOR_INFORMATION',
  TAB_PLAFON_CREDIT = 'TAB_PLAFON_CREDIT',
  TAB_PRODUCT_EXCLUSIVE = 'TAB_PRODUCT_EXCLUSIVE',
  TAB_PROGRAM_TARGET = 'TAB_PROGRAM_TARGET',
  TAB_ALAMAT_PENGIRIMAN = 'TAB_ALAMAT_PENGIRIMAN',
  TAB_DOCUMENTS = 'TAB_DOCUMENTS',
  TAB_LOG = 'TAB_LOG',
}

export enum TabLabelEnumDetailDistributor__LabelKey {
  TAB_NPWP_INFORMATION = 'informasi_npwp',
  TAB_KUL_INFORMATION = 'informasi_kul',
  TAB_DISTRIBUTOR_INFORMATION = 'informasi_distributor',
  TAB_PLAFON_CREDIT = 'plafon_kredit',
  TAB_PRODUCT_EXCLUSIVE = 'product_exclusive',
  TAB_PROGRAM_TARGET = 'program_target',
  TAB_ALAMAT_PENGIRIMAN = 'alamat_pengiriman',
  TAB_DOCUMENTS = 'dokumen',
  TAB_LOG = 'log',
}
